module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bxTBg"))).then(() => parcelRequire('d0iPb'));